import React from 'react';

export default function ChevronDown({ ...other }) {
  return (
    <svg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg' {...other}>
      <path d='M-6.11959e-08 1.4L1.4 -4.63341e-07L6 4.6L10.6 -6.11959e-08L12 1.4L6 7.4L-6.11959e-08 1.4Z' fill='white' />
    </svg>
  );
}
